import { useTranslation } from '@fluentsms/i18n';
import { IconButton, InputAdornment, makeStyles, TextField, TextFieldProps, Theme, Tooltip } from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';

export type DataGridSearchProps = TextFieldProps & {
  onHandleChange?: (value: string) => void;
  placeholder?: string;
  defaultValue?: string;
  value?: string;
  tooltipText?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  searchField: {
    width: 200,
    marginLeft: theme.spacing(1),
  },
  iconColor: {
    color: '#2e7ea8',
  },
}));

export const DataGridSearch = ({
  onHandleChange = () => undefined,
  placeholder,
  defaultValue,
  value = '',
  tooltipText,
  ...props
}: DataGridSearchProps): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [fieldValue, setFieldValue] = useState<string>(value as string);

  useEffect(() => {
    setFieldValue(value);
  }, [value]);

  return (
    <TextField
      {...props}
      className={classes.searchField}
      size="small"
      value={fieldValue}
      data-testid="data-grid-search-input"
      placeholder={placeholder || t('dataGridSearch.searchPlaceholder')}
      defaultValue={defaultValue}
      onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e?.target?.value;
        onHandleChange(value);
        setFieldValue(value);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" data-testid="search-icon">
            {tooltipText ? (
              <Tooltip
                title={tooltipText}
                hidden={true}
                placement="top"
                arrow
                data-testid="data-grid-searchIcon-tooltip"
              >
                <Search className={classes.iconColor} />
              </Tooltip>
            ) : (
              <Search className={classes.iconColor} />
            )}
          </InputAdornment>
        ),
        endAdornment: fieldValue && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              data-testid="clear-button"
              onClick={() => {
                onHandleChange('');
                setFieldValue('');
              }}
            >
              <Close fontSize="small" className={classes.iconColor} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default DataGridSearch;
